import { Container, Heading, Paragraph } from '@audio-network/componentlibrary'

import { Button } from '@audio-network/componentlibrary'
import React from 'react'
import { getSearch } from '@/utils/window'
import { sendAnalytics } from '@audio-network/analytics'
import styles from './TryAudioSearch.module.css'
import { usePathname } from 'next/navigation'
import { useTranslation } from 'next-i18next'

const TryAudioSearch = (): JSX.Element => {
	const { t } = useTranslation(['search'])

	const pathname = usePathname()
	const search = getSearch()

	const handleLoginClick = (): void => {
		sendAnalytics({
			noun: 'Login',
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Reference Search Panel',
			},
		})
	}

	const handleCreateAccountClick = (): void => {
		sendAnalytics({
			noun: 'Create Account',
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Reference Search Panel',
			},
		})
	}

	return (
		<Container className={styles.container} maxWidth="large">
			<Heading level={2} size="S">
				{t('try-audio-search-title')}
			</Heading>
			<Paragraph>{t('try-audio-search-description')}</Paragraph>
			<div className={styles.buttonsWrapper}>
				<Button
					href={`/login?returnurl=${encodeURIComponent(
						`${pathname}${search}`
					)}`}
					onClick={handleLoginClick}
					variant="secondary"
				>
					{t('login')}
				</Button>
				<Button
					href="/registration"
					onClick={handleCreateAccountClick}
					data-testid="audio-search-create-account"
				>
					{t('create-account')}
				</Button>
			</div>
		</Container>
	)
}

export default TryAudioSearch
